import { VertiIntegrationFlow } from '@global/enums';
import { createAction, props } from '@ngrx/store';
import { GenesysChat } from '@core/models/configurator';

export enum ProjectActions {
  EmptyFlowDataGeneral = '[Flow Data General] Empty Flow Data',
  UpdatePolicyHolderAddressCheckbox = '[Flow Data General] Update Policy Holder Address Checkbox',
  UpdatePartnershipId = '[Flow Data General] Update Partnership Id',
  UpdateUserId = '[Flow Data General] Update User Id',
  UpdateProjectId = '[Flow Data General] Update Project Id',
  UpdatePolicyId = '[Flow Data General] Update Policy Id',
  UpdatePolicyVersion = '[Flow Data General] Update Policy Version',
  UpdateSessionId = '[Flow Data General] Update Session Id',
  UpdateTkJwt = '[Flow Data General] Update JWT (token)',
  UpdateRtkJwt = '[Flow Data General] Update JWT (refresh token)',
  UpdateGWCookie = '[Flow Data General] Update GWCookie (API GW)',
  NoneUserParticipants = '[Flow Data General] None User Participants',
  IsPolicyFormPolicyNumber = '[Flow Data General] Is Policy Form Policy Number',
  IsMortgageBankData = '[Flow Data General] Is Mortgage Bank Data',
  PrivacyPolicyInd = '[Flow Data General] Privacy Policy Checkbox',
  MarketingResearchInd = '[Flow Data General] Marketing Research Radio button',
  CommercialCommInd = '[Flow Data General] Commercial Communications Radio button',
  BusinessResearchInd = '[Flow Data General] Business Communications Radio button',
  ProfilingInd = '[Flow Data General] Profiling Radio button',
  PartnershipIntegrationInd = '[Flow Data General] Partnership integration indicator',
  UserFlow = '[Flow Data General] User flow',
  UserJourney = '[Flow Data General] User journey',
  IsBackOfficeUser = '[Flow Data General] Is BackOffice User',
  GenesysChatInfo = '[Flow Data General] Update Genesys Chat Info',
  GenesysChatVisibilityInd = '[Flow Data General] Update Genesys Chat Visibility'
}

export const EmptyFlowDataGeneral = createAction(ProjectActions.EmptyFlowDataGeneral);

export const UpdatePolicyHolderAddressCheckbox = createAction(
  ProjectActions.UpdatePolicyHolderAddressCheckbox,
  props<{ data: boolean }>()
);

export const UpdatePartnershipId = createAction(ProjectActions.UpdatePartnershipId, props<{ data: string }>());

export const UpdateUserId = createAction(ProjectActions.UpdateUserId, props<{ data: string }>());

export const UpdateProjectId = createAction(ProjectActions.UpdateProjectId, props<{ data: string }>());

export const UpdatePolicyId = createAction(ProjectActions.UpdatePolicyId, props<{ data: string }>());

export const UpdatePolicyVersion = createAction(ProjectActions.UpdatePolicyVersion, props<{ data: string }>());

export const UpdateSessionId = createAction(ProjectActions.UpdateSessionId, props<{ data: string }>());

export const UpdateTkJwt = createAction(ProjectActions.UpdateTkJwt, props<{ data: string }>());

export const UpdateRtkJwt = createAction(ProjectActions.UpdateRtkJwt, props<{ data: string }>());

export const UpdateGWCookie = createAction(ProjectActions.UpdateGWCookie, props<{ data: string }>());

export const NoneUserParticipants = createAction(ProjectActions.NoneUserParticipants, props<{ data: boolean }>());

export const IsPolicyFormPolicyNumber = createAction(
  ProjectActions.IsPolicyFormPolicyNumber,
  props<{ data: boolean }>()
);

export const IsMortgageBankData = createAction(ProjectActions.IsMortgageBankData, props<{ data: boolean }>());

export const PrivacyPolicyInd = createAction(ProjectActions.PrivacyPolicyInd, props<{ data: boolean }>());

export const MarketingResearchInd = createAction(ProjectActions.MarketingResearchInd, props<{ data: boolean }>());

export const CommercialCommInd = createAction(ProjectActions.CommercialCommInd, props<{ data: boolean }>());

export const BusinessResearchInd = createAction(ProjectActions.CommercialCommInd, props<{ data: boolean }>());

export const ProfilingInd = createAction(ProjectActions.CommercialCommInd, props<{ data: boolean }>());

export const PartnershipIntegrationInd = createAction(
  ProjectActions.PartnershipIntegrationInd,
  props<{ data: boolean }>()
);

export const UserFlow = createAction(ProjectActions.UserFlow, props<{ data: VertiIntegrationFlow }>());

export const IsBackOfficeUser = createAction(ProjectActions.IsBackOfficeUser, props<{ data: boolean }>());

export const GenesysChatInfoData = createAction(ProjectActions.GenesysChatInfo, props<{ data: GenesysChat }>());

export const GenesysChatVisibilityInd = createAction(ProjectActions.GenesysChatVisibilityInd, props<{ data: boolean }>());
